const STATE_CONTROLLING_STATE = 'state controled url'
/**
 * When enabled allows you to stay on the page
 */
class StayOnPageControl {
  constructor (urlToControl) {
    this.enablePop = false
    this.removeStack = false
    this.urlToGoBackTo = urlToControl
    this.previousState = null
    this.hasSetOnPopState = false
    this.onRevertURL = () => {}    // this is a function that is called when the URL is reverted back (stays)
  }
  setOnRevertURL (func) {
    this.onRevertURL = func
  }
  isEnabled () {
    return this.enablePop && !this.removeStack
  }
  enable () {
    this.enablePop = true
    this.removeStack = false
    history.pushState(STATE_CONTROLLING_STATE, null, this.urlToGoBackTo)
    this.hasSetOnPopState = true
    let that = this
    window.onpopstate = function () {
      if (that.enablePop) {
        history.pushState(STATE_CONTROLLING_STATE, null, that.urlToGoBackTo)
        that.onRevertURL()
      }
      if (that.removeStack &&
        (history.state === STATE_CONTROLLING_STATE ||
        that.previousState === STATE_CONTROLLING_STATE)
      ) {
        that.previousState = history.state
        history.go(-1)
      } else if (that.removeStack) {

      }
    }
  }
  disable () {
    this.enablePop = false
    this.removeStack = true
    this.previousState = history.state
  }
}

export default StayOnPageControl



// WEBPACK FOOTER //
// ./src/app/clientLogic/history/StayOnPageControl.js